import styled from 'styled-components';

export const AdditionalFeatureContainerStyled = styled.div`
	gap: 6px;
	display: flex;
	flex-direction: row;
`;

export const AdditionalFeatureNameStyled = styled.p`
	margin: 0;
	color: #262626;
	font-weight: 400;
	font-size: 12px;
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 14px;
	}
`;

export const AdditionalFeaturePriceStyled = styled.p`
	margin: 0;
	color: #237804;
	font-weight: 400;
	font-size: 12px;
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		font-size: 14px;
	}
`;
